import { ActionBase } from '..';
import { UserRegisterGroomStep3 } from './model';

const BASE_ACTION = '@registerGroom';

const SET_LIST_EMAIL = `${BASE_ACTION}/SET_LIST_EMAIL`;
const setListEmail = (payload: UserRegisterGroomStep3[]): ActionBase => ({ payload, type: SET_LIST_EMAIL });

export { SET_LIST_EMAIL, setListEmail };
